export default {
  path: '/updated_lynxapis',
  name: 'updated_lynxapis',
  component: () => import('../components/updatedlynxapi/Layout'),
  redirect: { name: 'UpdatedLynxapiList' },
  meta: {
    breadcrumb: 'updatedlynxapi.updatedlynxapis',
  },
  children: [
    {
      name: 'UpdatedLynxapiList',
      path: '',
      component: () => import('../views/updatedlynxapi/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'UpdatedLynxapiShow',
      path: ':id',
      component: () => import('../views/updatedlynxapi/Show'),
      meta: {
        breadcrumb: 'updatedlynxapi.updatedlynxapi',
      },
    }
  ]
};
